import { BaseSearchParametersModel } from "../../models/base-search-parameters.model";

export class SearchParametersModel extends BaseSearchParametersModel {
    public searchContext: string;
    public templateId: string;
    public categories: Array<string>;
}
